import { Row } from 'react-bootstrap';

const FormRow = ({ children }) => (
	<Row xs={1} lg={2}>
		{children}
	</Row>
);

export default FormRow;
